import MuiButton from "@mui/material/Button";
import { styled } from "@mui/material/styles";

import { isDarkTheme } from "helpers/darkTheme";

import type { ReactNode } from "react";
import type { ButtonProps as MuiButtonProps } from "@mui/material/Button";

type ToggleButtonProps = {
  children?: ReactNode;
  selected?: boolean;
  ButtonProps?: MuiButtonProps;
};

export default function ToggleButton({ children, selected, ButtonProps }: ToggleButtonProps) {
  return (
    <Button
      size="large"
      color={selected ? "primary" : "secondary"}
      variant="outlined"
      selected={selected}
      disableRipple
      disableTouchRipple
      {...ButtonProps}
    >
      {children}
    </Button>
  );
}

type ButtonProps = {
  selected?: boolean;
};

const Button = styled(MuiButton)<ButtonProps>`
  min-width: 85px;
  transition: all 0.2s ease;
  border-color: ${({ theme, selected }) =>
    selected ? (isDarkTheme(theme.palette.mode) ? "#fff" : "#000") : ""};
`;
